import { useState, useEffect } from 'react';
import { collection, onSnapshot, QuerySnapshot, DocumentData } from 'firebase/firestore';
import { db } from '../firebase/config';
import { MaerkeDag } from '../types';

interface UseMaerkeDageResult {
  maerkeDage: MaerkeDag[];
  loading: boolean;
  error: string | null;
}

export function useMaerkeDage(): UseMaerkeDageResult {
  const [maerkeDage, setMaerkeDage] = useState<MaerkeDag[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const ref = collection(db, 'maerkeDage');
    const unsubscribe = onSnapshot(
      ref,
      (snapshot: QuerySnapshot<DocumentData>) => {
        const data: MaerkeDag[] = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as MaerkeDag[];
        setMaerkeDage(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Fejl ved hentning af mærkedage:', err);
        setError('Kunne ikke hente mærkedage. Prøv igen senere.');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { maerkeDage, loading, error };
}
